import createAsyncReducer from '../../core/helpers/createAsyncReducer';
import { LOBBY_TYPES } from '../../core/constants/actionTypes';

export const lobbyReducers = createAsyncReducer(LOBBY_TYPES.GET_LOBBY.PREFIX, {matches: [], round: {}, user: {}});
export const weeklyLeaderBoardReducer = createAsyncReducer(LOBBY_TYPES.GET_WEEKLY_LEADERBOARD.PREFIX, {count: 0, users: [], user: {}});
export const globalLeaderBoardReducer = createAsyncReducer(LOBBY_TYPES.GET_GLOBAL_LEADERBOARD.PREFIX, {count: 0, users: [], user: {}});
export const historyReducer = createAsyncReducer(LOBBY_TYPES.GET_HISTORY.PREFIX, []);
